import React from "react";
import { Accordion } from "react-bootstrap";
import {
  Icon,
  IconColorStyle,
  IconSize,
  useFlowController,
  useFlowData,
  FlowTypes,
} from "@adaptis/flow-components";
import { IPetsyCoverSummaryProps } from "./PetsyCoverSummary.types";

import "./PetsyCoverSummary.scss";

export default function PetsyCoverSummary(props: IPetsyCoverSummaryProps) {
  const { getData } = useFlowData();
  let petAgeOnStartDatePolicy = getData("petAgeOnStartDatePolicy");
  let showExtraSummary = petAgeOnStartDatePolicy > 1094 ? false : true;
  let coverType = getData("coverType");
  let optionalExtras = "";
  if (coverType && coverType === "custom") {
    optionalExtras = getData("customCover.optionalExtras");
  }

  let extraBenefitsSelected = "Not selected";
  let extraBenefitsIconStyle = IconColorStyle.Warning;
  let extraBenefitsIconImage = props.crossImage ? props.crossImage : "";

  if (props.optionalExtraBenefitsIncluded || optionalExtras === "yes") {
    extraBenefitsSelected = "Selected";
    extraBenefitsIconStyle = IconColorStyle.Success;
    extraBenefitsIconImage = props.tickImage ? props.tickImage : "";
  }
  return (
    <div
      data-testid="PetsyCoverSummary"
      className={
        "flc_petsy-cover-summary " + (props.className ? props.className : "")
      }
    >
      <h2 className="mt-3 mb-3">We cover</h2>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <Icon
              className="me-2"
              src={props.tickImage ? props.tickImage : ""}
              colorStyle={IconColorStyle.Success}
              size={IconSize.ExtraSmall}
            />
            Vet Costs if Your Pet is Injured
          </Accordion.Header>
          <Accordion.Body>
            <p>
              If during the Period of Insurance and after any applicable exclusion period, Your Pet suffers an Injury due to an Accident and You incur
              Vet Costs for required Treatment (excluding Specialised Therapies),
              We will reimburse or pay a portion of Your incurred Vet Costs
              related to the Treatment up to the Benefit Percentage and subject to
              the Annual Limit and Annual Excess as shown in Your Certificate of
              Insurance.
            </p>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>
            <Icon
              className="me-2"
              src={props.tickImage ? props.tickImage : ""}
              colorStyle={IconColorStyle.Success}
              size={IconSize.ExtraSmall}
            />
            Vet Costs if Your Pet suffers an Illness
          </Accordion.Header>
          <Accordion.Body>
            <p>
              If during the Period of Insurance and after any applicable exclusion period,Your Pet suffers an Illness (excluding Dental Illness and
              Behavioural Conditions) and You incur Vet Costs for required Treatment
              (excluding Specialised Therapies), We will reimburse or pay a
              portion of Your incurred Vet Costs related to the Treatment up to
              the Benefit Percentage and subject to the Annual Limit and Annual
              Excess as shown in Your Certificate of Insurance.
            </p>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header>
            <Icon
              className="me-2"
              src={props.tickImage ? props.tickImage : ""}
              colorStyle={IconColorStyle.Success}
              size={IconSize.ExtraSmall}
            />
            Vet Costs for essential euthanasia
          </Accordion.Header>
          <Accordion.Body>
            <p>
              If during the Period of Insurance and after any applicable Exclusion
              Period, it is deemed necessary by Your Vet to euthanise Your Pet
              because of a covered Injury or Illness, We will reimburse or pay a
              portion of Your incurred Vet Costs related to euthanasia up to the
              Benefit Percentage and subject to the Annual Limit and Annual Excess
              as shown in Your Certificate of Insurance.
            </p>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="3">
          <Accordion.Header>
            <Icon
              className="me-2"
              style={{ width: "40px" }} // Hack this needs to be fixed properly
              src={props.tickImage ? props.tickImage : ""}
              colorStyle={IconColorStyle.Success}
              size={IconSize.ExtraSmall}
            />
            Vets Costs Overseas (while in New Zealand or Norfolk Islands on
            trips less than sixty (60) days)
          </Accordion.Header>
          <Accordion.Body>
            <p>
              If during the Period of Insurance and after any applicable Waiting Period,
              Your Pet accompanies You on a trip of not more than sixty (60) days
              to New Zealand or Norfolk Island and suffers an Injury or Illness
              (excluding Dental Illness or Behavioural Problems) and
              You incur Vet Costs for:
            </p>
            <p>
              a. required Treatment (excluding Specialised Therapies); and/or
            </p>
            <p>b. euthanasia if deemed humane and essential by Your Vet,</p>
            <p>
              We will reimburse or pay a portion of Your incurred Vet Costs
              related to Treatment and/or euthanasia up to the Benefit
              Percentage and subject to the Annual Limit and Annual Excess as
              shown in Your Certificate of Insurance.
            </p>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="4">
          <Accordion.Header>
            <Icon
              className="me-2"
              src={props.tickImage ? props.tickImage : ""}
              colorStyle={IconColorStyle.Success}
              size={IconSize.ExtraSmall}
            />
            Emergency Pet boarding
          </Accordion.Header>
          <Accordion.Body>
            <p>
              If during the Period of Insurance, You are unexpectedly hospitalised
              for four (4) or more consecutive days, and it is not reasonable for
              someone who lives with You to look after Your Pet and is therefore
              necessary for Your Pet to board at a licenced kennel or cattery, We
              will reimburse a portion of Your incurred boarding costs for a
              period of up to 30 days up to the Benefit Percentage and subject to
              the Annual Limit and Annual Excess as shown in Your Certificate of
              Insurance.
            </p>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
      {
        showExtraSummary && <>
          <h2 className="mt-5 mb-3">
            Optional Extra Benefits ({extraBenefitsSelected})
          </h2>
          <Accordion>
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <Icon
                  className="me-2"
                  src={extraBenefitsIconImage}
                  colorStyle={extraBenefitsIconStyle}
                  size={IconSize.ExtraSmall}
                />
                Vet Costs if Your Pet suffers a Dental Illness
              </Accordion.Header>
              <Accordion.Body>
                <p>
                  If during the Period of Insurance and after any applicable exclusion period, Your Pet suffers a Dental Illness and You incur Vet Costs
                  for required Treatment (excluding Specialised Therapies), We will
                  reimburse or pay a portion of Your incurred Vet Costs related to
                  the Treatment up to the Benefit Percentage and subject to the
                  Annual Limit and Annual Excess as shown in Your Certificate of
                  Insurance.
                </p>
                <p>
                  Examples of Dental Illnesses:<br />
                  Dental diseases, gingivitis, periodontal disease, gingival (gum), tumours and growths.
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="1">
              <Accordion.Header>
                <Icon
                  className="me-2"
                  src={extraBenefitsIconImage}
                  colorStyle={extraBenefitsIconStyle}
                  size={IconSize.ExtraSmall}
                />
                Vet Costs if Your Pet suffers from Behavioural Conditions
              </Accordion.Header>
              <Accordion.Body>
                <p>
                  If during the Period of Insurance and after any applicable
                  Exclusion Period, Your Pet suffers a Behavioural Condition and You
                  incur Vet Costs from a generalist Vet or a behavioural specialist
                  Vet including costs related to supply of registered medications
                  for required Treatment (excluding Specialised Therapies), We will
                  reimburse or pay a portion of Your incurred Vet Costs related to
                  the Treatment up to the Benefit Percentage and subject to the
                  Annual Limit and Annual Excess as shown in Your Certificate of
                  Insurance.
                </p>
                <p>
                  Examples of Behavioural Conditions: <br />
                  Excessive licking, fur pulling, pacing, destructive chewing, anxiety, aggression and obsessive behavioural disorders.
                </p>
              </Accordion.Body>
            </Accordion.Item>
            <Accordion.Item eventKey="2">
              <Accordion.Header>
                <Icon
                  className="me-2"
                  src={extraBenefitsIconImage}
                  colorStyle={extraBenefitsIconStyle}
                  size={IconSize.ExtraSmall}
                />
                Vet Costs for Specialised Therapies to treat covered Conditions
              </Accordion.Header>
              <Accordion.Body>
                <p>
                  If during the Period of Insurance and after any applicable exclusion period, Your Pet suffers an Injury or Illness and You incur Vet
                  Costs for required Specialised Therapies Treatment, We will
                  reimburse or pay a portion of Your incurred Vet Costs related to
                  the Specialised Therapies Treatment up to the Benefit Percentage
                  and subject to the Annual Limit and Annual Excess as shown in Your
                  Certificate of Insurance.
                </p>
                <p>
                  Example Specialised Therapies: Acupuncture, physiotherapy,
                  hydrotherapy.
                </p>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </>
      }


      <h2 className="mt-5 mb-3">We don't cover</h2>
      <Accordion>
        <Accordion.Item eventKey="0">
          <Accordion.Header>
            <Icon
              className="me-2"
              src={props.crossImage ? props.crossImage : ""}
              colorStyle={IconColorStyle.Warning}
              size={IconSize.ExtraSmall}
            />
            Pre-existing Symptoms and Conditions
          </Accordion.Header>
          <Accordion.Body>
            <p>
              There is no cover under this Policy for Vet Costs for Treatment of Pre-existing
              Symptoms and Conditions, unless an exception to this exclusion is approved by
              Us after a Pre-existing Symptom and Condition assessment (as set out below).
            </p>
            <p>A Pre-existing Symptom and Condition is defined as:</p>
            <p>
              An Injury, Illness, Dental Illness, Behavioural Condition or Specified Condition
              (including Bilateral Conditions, recurrent Conditions and other Conditions that
              are related to, secondary to, or results of) that:
            </p>
            <div style={{ marginLeft: "20px" }}>
              <ol type="a">
                <li>first occurred or showed symptoms of, or </li>
                <li>was identified or investigated by a Vet, or</li>
                <li>
                  You were aware of or a reasonable person in the circumstances could be
                  expected to have known about,
                </li>
              </ol>
            </div>
            <p>
              before Your Pet’s First Date of Cover, before any applicable Exclusion Period has
              finished, or if You increase Your cover before a change of cover became
              effective.
            </p>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="1">
          <Accordion.Header>
            <Icon
              className="me-2"
              src={props.crossImage ? props.crossImage : ""}
              colorStyle={IconColorStyle.Warning}
              size={IconSize.ExtraSmall}
            />
            Preventive and routine items
          </Accordion.Header>
          <Accordion.Body>
            <div style={{ marginLeft: "20px" }}>
              Preventive and routine items to take care of Your Pet including:
              <ul>
                <li>health exams, annual check-ups and vaccinations; </li>
                <li>parasite prevention;</li>
                <li>shampoo/conditioners including medicated ones;</li>
                <li>food, including prescription food and supplements.</li>
              </ul>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="2">
          <Accordion.Header>
            <Icon
              className="me-2"
              src={props.crossImage ? props.crossImage : ""}
              colorStyle={IconColorStyle.Warning}
              size={IconSize.ExtraSmall}
            />
            Desexing
          </Accordion.Header>
          <Accordion.Body>
            <p>
              There is no cover for the spaying or neutering of your pet. We do
              however cover additional Vet Costs for required Treatment of
              complex cryptorchid (undescended testicles) if it is not a
              Pre-existing Condition. We will reduce the Vet Costs by the amount
              the Vet would have charged for neutering before applying the
              Benefit Percentage.
            </p>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="3">
          <Accordion.Header>
            <Icon
              className="me-2"
              src={props.crossImage ? props.crossImage : ""}
              colorStyle={IconColorStyle.Warning}
              size={IconSize.ExtraSmall}
            />
            Brachycephalic Obstructive Airway Syndrome (BOAS)
          </Accordion.Header>
          <Accordion.Body>
            <p>
              We do not cover Vet Costs or any other costs attributable to Treatment for
              Brachycephalic Obstructive Airway Syndrome (BOAS) unless the
              Brachycephalic Obstructive Airway Syndrome BOAS Application form is completed and accepted by Us.
            </p>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="4">
          <Accordion.Header>
            <Icon
              className="me-2"
              src={props.crossImage ? props.crossImage : ""}
              colorStyle={IconColorStyle.Warning}
              size={IconSize.ExtraSmall}
            />
            Your actions including Pet care
          </Accordion.Header>
          <Accordion.Body>
            <div style={{ marginLeft: "20px" }}>
              <ul>
                <li>
                  Actions or neglect resulting in Vet Costs or additional Vet
                  Costs including not following Your Vet's advice
                </li>
                <li>Vaccinatable diseases if not up to date with vaccinations</li>
              </ul>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="5">
          <Accordion.Header>
            <Icon
              className="me-2"
              src={props.crossImage ? props.crossImage : ""}
              colorStyle={IconColorStyle.Warning}
              size={IconSize.ExtraSmall}
            />
            Certain treatments
          </Accordion.Header>
          <Accordion.Body>
            <div style={{ marginLeft: "20px" }}>
              <ul>
                <li>
                  Specialised Therapies (unless You have chosen to include
                  Optional Extra Benefits)
                </li>
                <li>Experimental Treatments</li>
                <li>Breeding related Treatments</li>
                <li>Elective procedures or activities</li>
              </ul>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="6">
          <Accordion.Header>
            <Icon
              className="me-2"
              src={props.crossImage ? props.crossImage : ""}
              colorStyle={IconColorStyle.Warning}
              size={IconSize.ExtraSmall}
            />
            Certain Vet Costs
          </Accordion.Header>
          <Accordion.Body>
            <div style={{ marginLeft: "20px" }}>
              <ul>
                <li>Emergency costs when it was not an emergency</li>
                <li>
                  Medications not registered or approved in Australia (or in New
                  Zealand/Norfolk Island in respect of section 4 in the PDS)
                </li>
                <li>Costs after Your Pet's death</li>
              </ul>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="7">
          <Accordion.Header>
            <Icon
              className="me-2"
              src={props.crossImage ? props.crossImage : ""}
              colorStyle={IconColorStyle.Warning}
              size={IconSize.ExtraSmall}
            />
            Other General exclusions
          </Accordion.Header>
          <Accordion.Body>
            <div style={{ marginLeft: "20px" }}>
              <ul>
                <li>Exclusion Periods</li>
                <li>Epidemics, pandemics or new influenza</li>
                <li>Nuclear or radioactive weapons/materials</li>
                <li>Acts of war or civil unrest</li>
                <li>
                  Any illness or injury whist Your Pet is under a transport
                  company’s care, such as an airline or courier.
                </li>
                <li>
                  Natural Catastrophe and Natural Disaster
                </li>
              </ul>
            </div>
          </Accordion.Body>
        </Accordion.Item>
        <Accordion.Item eventKey="8">
          <Accordion.Header>
            <Icon
              className="me-2"
              src={props.crossImage ? props.crossImage : ""}
              colorStyle={IconColorStyle.Warning}
              size={IconSize.ExtraSmall}
            />
            Optional Extra Benefits for pets over 3 years
          </Accordion.Header>
          <Accordion.Body>
            <p>
              You cannot add Optional Extra Benefits for your pets if they are 3 years old or older.
              This is due to the increased likelihood of Pre-existing symptoms and conditions impacting future
              coverage for pets over 3 years old, and it’s important to us that our cover genuinely serves the interests of pet owners.
            </p>
            <p>
              For example, over 80% of dogs and cats develop dental disease by this age, including gingivitis, plaque/tartar and calculus.
              Although our Optional Extra Benefits include Dental Illness coverage, it doesn’t apply to pre-existing conditions.
            </p>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    </div>
  );
}
